export const preloadVideo = (src) => {
  const video = document.createElement('video');
  video.src = src;
};

/**
 * Preload an image with optional callback.
 * @param src : url for image to preload;
 * @param callback : optional callback after the image has been loaded.
 */
export const preloadImage = (src: string, callback?: EventListener) => {
  const image = new Image();
  if (callback) image.addEventListener('load', callback, { once: true });
  image.src = src;

  return image;
};

export const preloadAudio = (src) => {
  const audio = document.createElement('audio');
  audio.src = src;
};
